import { ArrayQ } from "@pdfking/structs"
import { RecordMerge } from "@pdfking/tfunc"

import type { ChoiceRecord, Choices } from "#public"

// `choices` merged into one key → value map (for lookups).
export const ChoiceFlat = <T>(choices: Choices<T>): ChoiceRecord<T> =>
  ArrayQ(choices) ? RecordMerge(...choices.map(([, group]) => group)) : choices
